<div class="app-container">
  <header class="app-header" *ngIf="currentUser && !isShareRoute">
    <!-- C2: the title and its tagline used to own a row of their own, above
         another row for the domain bar and two more for the nav. "Taptimize
         MK2 / SEO optimization and content analysis platform" tells you which
         app you are in, which you already know, and it cost about a quarter of
         the viewport on every screen. The wordmark now sits inline with the
         domain it applies to; the tagline is gone. -->
    <div class="global-domain-bar" *ngIf="availableDomains.length > 0">
      <h1 class="header-wordmark">Taptimize</h1>
      <label for="global-domain-select" class="global-domain-label">Active domain</label>
      <select
        id="global-domain-select"
        class="global-domain-select input"
        [ngModel]="selectedDomain"
        (ngModelChange)="onDomainChange($event)"
      >
        <option *ngFor="let domain of availableDomains" [value]="domain">{{ domain }}</option>
      </select>

      <div class="domain-settings">
        <button
          type="button"
          class="btn"
          (click)="toggleCompetitorMenu()"
          [attr.aria-expanded]="isCompetitorMenuOpen"
          aria-controls="domain-settings-panel"
          [disabled]="!selectedDomain"
        >
          <span class="domain-settings-icon" aria-hidden="true">&#9881;</span>
          <span>Settings</span>
        </button>

        <div
          id="domain-settings-panel"
          class="domain-settings-panel"
          *ngIf="isCompetitorMenuOpen"
        >
          <p class="domain-settings-title">{{ selectedDomain }}</p>
          <p class="domain-settings-helper">Competitors are saved per active domain.</p>

          <form class="competitor-add-row" (ngSubmit)="addCompetitor()">
            <input
              type="text"
              class="input"
              [(ngModel)]="newCompetitorInput"
              name="competitorDomain"
              placeholder="Add domain (example.com)"
              [disabled]="isSavingCompetitor"
            />
            <button
              type="submit"
              class="btn btn--accent"
              [disabled]="isSavingCompetitor"
            >
              Add
            </button>
          </form>

          <p class="competitor-status" *ngIf="isLoadingCompareSettings">Loading competitors...</p>
          <p class="competitor-status competitor-error" *ngIf="compareError">{{ compareError }}</p>
          <p class="competitor-status" *ngIf="!isLoadingCompareSettings && !compareError && markedCompetitors.length === 0">
            Add your first competitor for this domain.
          </p>

          <ul
            class="competitor-list"
            *ngIf="!isLoadingCompareSettings && markedCompetitors.length > 0"
          >
            <li *ngFor="let domain of markedCompetitors" class="competitor-list-item">
              <span class="competitor-domain">{{ domain }}</span>
              <div class="competitor-actions">
                <button
                  type="button"
                  class="btn btn--sm"
                  (click)="toggleCompareCompetitor(domain)"
                  [disabled]="isSavingCompetitor || isSavingCompareSelection"
                >
                  {{ isComparedDomain(domain) ? 'Comparing' : 'Compare' }}
                </button>
                <button
                  type="button"
                  class="btn btn--sm btn--danger"
                  (click)="removeCompetitor(domain)"
                  [disabled]="isSavingCompetitor || isSavingCompareSelection"
                >
                  Remove
                </button>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <span class="domain-competitor-summary">
        {{ isLoadingCompareSettings ? 'Loading competitors...' : competitorSummaryText }}
      </span>
      <span class="domain-compare-summary" *ngIf="selectedCompareDomain">
        Comparing: {{ selectedCompareDomain }}
      </span>
    </div>
    <nav class="nav-bar">
      <div class="nav-links">
        <!-- Core navigation (always visible) -->
        <a routerLink="/dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Dashboard</a>
        <a routerLink="/page-comparison" routerLinkActive="active">Compare</a>
        <a routerLink="/inventory" routerLinkActive="active">Inventory</a>

        <!-- Experimental navigation (feature-flagged) -->
        <a *ngIf="featureFlags.isEnabled('setup')" routerLink="/setup" routerLinkActive="active">Setup</a>
        <a *ngIf="featureFlags.isEnabled('clusters')" routerLink="/clusters" routerLinkActive="active">Clusters</a>
        <a *ngIf="featureFlags.isEnabled('domainTopics') || featureFlags.isUserView()" routerLink="/domain-topics" routerLinkActive="active">Domain Topics</a>
        <a *ngIf="featureFlags.isEnabled('crawlManagement')" routerLink="/crawl-management" routerLinkActive="active">Crawl Management</a>
        <a *ngIf="featureFlags.isEnabled('keywordResearch')" routerLink="/keyword-research-test" routerLinkActive="active">Keyword Research</a>
        <a *ngIf="featureFlags.isEnabled('competitorFinder')" routerLink="/competitor-finder" routerLinkActive="active">Competitor Finder</a>
      </div>

      <div class="nav-actions">
        <span class="nav-welcome">Welcome, {{ currentUser.name }}</span>
        <!-- Quiet, not danger. Red is the destructive tone -- it belongs on the
             controls that lose data. Signing out loses nothing, and painting it
             red both overstates this action and cheapens the tone for the ones
             that genuinely need it. -->
        <button (click)="logout()" class="btn btn--quiet">Logout</button>
      </div>
    </nav>
  </header>

  <!-- Dev/User View toggle (non-production only) -->
  <div class="dev-view-toggle" *ngIf="!featureFlags.isProduction() && currentUser && !isShareRoute">
    <button (click)="toggleDevUserView()" type="button" class="btn btn--sm btn--quiet">
      {{ featureFlags.isUserView() ? '👤 User View' : '🛠️ Dev View' }}
    </button>
  </div>

  <main>
    <router-outlet></router-outlet>
  </main>
  <app-global-notification-stack></app-global-notification-stack>
</div>


